import React from "react";
import GCalendar from './calendar/calendar';
import { Icon } from '@iconify/react';
import './styles/style.scss';

const Calendar = ({ pageState, setPageState }) => {
  const onEventSelected = (args) => {
    setPageState({
      ...pageState,
      "consultation": args.start
    })
  }

  return (
    <>
     <h1 className="title"><Icon icon="akar-icons:calendar" /> Schedule a Consultation</h1>
     <p>Please select a time slot for your consultation.</p>
     <p>All times in Eastern Standard Time.</p>
     <GCalendar onEventSelected={onEventSelected} />
    </>
  )
}

export default Calendar; 